module.exports = __webpack_public_path__ + "img/2.4efbb5f5.jpg";